export class Respuesta {
  error: string;
  mensaje: string;
  data: any[];
}
